module.exports = __webpack_public_path__ + "static/media/fantest_question_2_2.a0eef3c4.png";